import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import {styles} from './CreateDocumentModal.styles';
import {
  getAllowedReportTypes,
  getEffectiveSourceType,
  REPORT_TYPE_OPTIONS,
  shouldRestrictDocumentType,
} from './CreateDocumentModal.utils';

export const ReportTypeSelector = ({
  createFlow,
  documentType,
  previousDocument,
  setDocumentType,
  sourceDocumentType,
}) => {
  const effectiveSourceType = getEffectiveSourceType(
    previousDocument,
    sourceDocumentType
  );
  const shouldRestrict = shouldRestrictDocumentType(
    createFlow,
    previousDocument,
    sourceDocumentType
  );

  const allowedTypes = shouldRestrict
    ? getAllowedReportTypes(effectiveSourceType)
    : getAllowedReportTypes(null);

  return (
    <Stack direction="column" spacing="0.5rem">
      <Typography style={styles.modal.label}>Report type *</Typography>
      <Select
        onChange={(e) => setDocumentType(e.target.value)}
        sx={styles.modal.select}
        value={documentType}
      >
        {REPORT_TYPE_OPTIONS.map(({label, type}) => (
          <MenuItem
            disabled={!allowedTypes.includes(type)}
            key={type}
            value={type}
          >
            {label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

ReportTypeSelector.propTypes = {
  createFlow: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  previousDocument: PropTypes.object,
  setDocumentType: PropTypes.func.isRequired,
  sourceDocumentType: PropTypes.string,
};
